import { evaluates } from './evaluates'

export function lets () {
  return evaluates('let a = 1')
}
